/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';

/**
 * Empty component.
 *
 * Used when no fallback component is provided.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    // tslint:disable-next-line
    render: (h) => {
        return h();
    },
})
export default class EmptyComponent extends Vue {
}

